import React from "react"

const BalanceContext =
    React.createContext({
        balance: 0,
        updateBalance: (newBalance: number) => { }
    })

export default BalanceContext;
